import React from 'react';
import { motion } from 'framer-motion';
import { Sliders, Paintbrush, Monitor, Zap, RefreshCw, FileCode } from 'lucide-react';
const features = [{
  icon: Sliders,
  title: 'Infinite Customization',
  description: 'From eye color to armor texture, tweak every detail to match your vision perfectly.'
}, {
  icon: Paintbrush,
  title: 'Multiple Art Styles',
  description: 'Anime, realistic, pixel art, or cartoon - pick the aesthetic that suits your game.'
}, {
  icon: Monitor,
  title: 'Cross-Platform Ready',
  description: 'Optimized formats for Steam, Discord, Twitch, and all major gaming platforms.'
}, {
  icon: Zap,
  title: 'Quick Turnaround',
  description: 'Get your initial drafts in as little as 48 hours. Speed meets quality.'
}, {
  icon: RefreshCw,
  title: 'Revision Rounds',
  description: "We work with you until it's perfect. Your satisfaction is our main quest."
}, {
  icon: FileCode,
  title: 'Source Files Included',
  description: 'Full ownership with editable source files for future modifications.'
}];
export function FeaturesSection() {
  return <section id="features" className="py-24 bg-[#0B0B15] relative" data-id="element-10">
      <div className="container mx-auto px-4" data-id="element-11">
        <div className="text-center mb-16" data-id="element-12">
          <span className="text-fuchsia-500 font-bold tracking-wider uppercase text-sm" data-id="element-13">
            Features
          </span>
          <h2 className="text-3xl md:text-5xl font-bold font-display mt-2 mb-4" data-id="element-14">
            Crafted for <span className="text-cyan-400" data-id="element-15">Gamers</span>
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto" data-id="element-16">
            Everything you need to build your ultimate digital persona.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-17">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white/5 border border-white/5 rounded-2xl p-6 hover:bg-white/10 transition-colors group" data-id="element-18">
              <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-fuchsia-600 to-purple-600 flex items-center justify-center mb-4 group-hover:scale-110 transition-transform" data-id="element-19">
                <feature.icon className="w-6 h-6 text-white" data-id="element-20" />
              </div>
              <h3 className="text-xl font-bold text-white mb-2 font-display" data-id="element-21">
                {feature.title}
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-22">
                {feature.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}